/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotoother3Inputs */

const en_aiflowphotoother3 = /** @type {(inputs: Aiflowphotoother3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another photo`)
};

const de_aiflowphotoother3 = /** @type {(inputs: Aiflowphotoother3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anderes Foto`)
};

/**
* | output |
* | --- |
* | "Another photo" |
*
* @param {Aiflowphotoother3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotoother3 = /** @type {((inputs?: Aiflowphotoother3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotoother3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotoother3(inputs)
	return de_aiflowphotoother3(inputs)
});
export { aiflowphotoother3 as "aiFlowPhotoOther" }